import { PERMISSIONS } from 'api/auth/constants';
import { REPORT_PATHS } from 'api/reports/constants';
import { ROUTES } from 'routes/config/constants';
import { TABS } from 'routes/pages/AuthorizedStack/Clients/ClientsList/Client/View/Tabs/constants';
import { TABS_TYPE } from 'routes/pages/AuthorizedStack/Invoices/constants';
import { CONTRACT_TABS } from 'routes/pages/AuthorizedStack/Settlement/SettlementContracts/SettlementContract/View/constants';
import { BLACK_LIST_TYPE } from 'routes/pages/AuthorizedStack/TrafficManagement/Blacklists/constants';

import { DOWNLOAD_KEYS } from './constants';
import { IReports } from './types';

export const REPORTS: Record<string, IReports[]> = {
  [ROUTES.CLIENTS_MANAGEMENT.SUB_PATH.CLIENTS_INSTRUMENTS.PATH]: [
    {
      path: 'clients-instruments/reports',
      permissions: [PERMISSIONS.CAN_CREATE_CLIENTS_INSTRUMENTS_REPORTS],
    },
  ],
  [ROUTES.CLIENTS_MANAGEMENT.SUB_PATH.CLIENTS.PATH]: [
    {
      path: 'customers/reports',
      permissions: [PERMISSIONS.CAN_CREATE_CLIENTS_REPORTS],
    },
  ],
  [ROUTES.CLIENTS_MANAGEMENT.SUB_PATH.CLIENTS.SUB_PATH.CLIENT.PATH]: [
    {
      path: 'transactions/reports',
      permissions: [PERMISSIONS.CAN_CREATE_TRANSACTION_REPORTS],
      tab: TABS.TRANSACTIONS,
    },
  ],
  [ROUTES.INVOICES.PATH]: [
    {
      path: 'gateway-invoices/reports',
      permissions: [PERMISSIONS.CAN_CREATE_GATEWAY_INVOICE_REPORTS],
      tab: TABS_TYPE.GATEWAY_INVOICES,
    },
  ],
  [ROUTES.INVOICES.SUB_PATH.GATEWAY_INVOICE.EDIT.PATH]: [
    {
      path: REPORT_PATHS.GATEWAY_INVOICE_DETAILS,
      permissions: [PERMISSIONS.CAN_CREATE_GATEWAY_INVOICE_DETAILS_REPORTS],
    },
  ],
  [ROUTES.MERCHANTS_SETTINGS.SUB_PATH.CASHIER_LIMITS.PATH]: [
    {
      path: 'cashier-page-limits/reports',
      permissions: [PERMISSIONS.CAN_CREATE_CASHIER_LIMITS_REPORTS],
    },
  ],
  [ROUTES.MERCHANTS_SETTINGS.SUB_PATH.CASHIER_SETTINGS.PATH]: [
    {
      path: 'cashier-settings/reports',
      permissions: [PERMISSIONS.CAN_CREATE_CASHIER_SETTINGS_REPORTS],
    },
  ],
  [ROUTES.MERCHANTS_SETTINGS.SUB_PATH.PAYMENT_METHODS.PATH]: [
    {
      path: 'cashier-payment-methods/reports',
      permissions: [PERMISSIONS.CAN_CREATE_CASHIER_PAYMENT_METHODS_REPORTS],
    },
  ],
  [ROUTES.MERCHANTS.PATH]: [
    {
      path: 'merchants/terminals/reports',
      permissions: [PERMISSIONS.CAN_CREATE_MERCHANT_TERMINAL_REPORTS],
    },
  ],
  [ROUTES.PSP_MANAGEMENT.SUB_PATH.PSP.PATH]: [
    {
      path: 'banks/reports',
      permissions: [PERMISSIONS.CAN_CREATE_BANKS_REPORTS],
    },
  ],
  [ROUTES.PSP_MANAGEMENT.SUB_PATH.TERMINAL_LINKS_PARAMETERS.PATH]: [
    {
      path: 'terminal-links/parameters/reports',
      permissions: [PERMISSIONS.CAN_CREATE_TERMINAL_LINKS_PARAMETERS_REPORTS],
    },
  ],
  [ROUTES.PSP_MANAGEMENT.SUB_PATH.TERMINALS_LINKS.PATH]: [
    {
      path: 'terminal-links/reports',
      permissions: [PERMISSIONS.CAN_CREATE_TERMINAL_LINKS_REPORTS],
    },
  ],
  [ROUTES.RECONCILIATION.SUB_PATH.VIEW.SUB_PATH.FILE.PATH]: [
    {
      path: REPORT_PATHS.RECONCILIATION_RESULTS,
      permissions: [PERMISSIONS.CAN_CREATE_RECONCILIATION_REPORTS],
    },
  ],
  [ROUTES.SETTLEMENT.SETTLEMENT_CONTRACTS.SETTLEMENT_CONTRACT.PATH]: [
    {
      key: DOWNLOAD_KEYS.CONTRACT_WORKBOOK,
      path: REPORT_PATHS.SETTLEMENT_CONTRACT_WORKBOOK,
      permissions: [PERMISSIONS.CAN_CREATE_SETTLEMENT_CONTRACTS_WORKBOOK_REPORTS],
      tab: CONTRACT_TABS.WORKBOOK,
    },
    {
      key: DOWNLOAD_KEYS.CONTRACT_TRANSACTIONS,
      path: REPORT_PATHS.SETTLEMENT_CONTRACT_TRANSACTIONS,
      permissions: [PERMISSIONS.CAN_CREATE_SETTLEMENT_CONTRACTS_WORKBOOK_REPORTS],
      tab: CONTRACT_TABS.WORKBOOK,
    },
  ],
  [ROUTES.TRAFFIC_MANAGEMENT.SUB_PATH.BLACKLISTS.PATH]: [
    {
      path: 'blacklists/card-masks/reports',
      permissions: [PERMISSIONS.CAN_CREATE_BLACKLISTS_CARD_MASKS_REPORTS],
      tab: BLACK_LIST_TYPE.CARD_MASK,
    },
    {
      path: 'blacklists/emails/reports',
      permissions: [PERMISSIONS.CAN_CREATE_BLACKLISTS_EMAIL_REPORTS],
      tab: BLACK_LIST_TYPE.EMAILS,
    },
    {
      path: 'blacklists/ip-address/reports',
      permissions: [PERMISSIONS.CAN_CREATE_BLACKLISTS_IP_REPORTS],
      tab: BLACK_LIST_TYPE.IP_ADDRESSES,
    },
  ],
  [ROUTES.TRAFFIC_MANAGEMENT.SUB_PATH.ROUTING_RULESET.PATH]: [
    {
      path: 'routing-rulesets/reports',
      permissions: [PERMISSIONS.CAN_CREATE_RULESET_REPORTS],
    },
  ],
  [ROUTES.TRANSACTIONS.PATH]: [
    {
      path: 'transactions/reports',
      permissions: [PERMISSIONS.CAN_CREATE_TRANSACTION_REPORTS],
    },
  ],
};
